// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes page_progress__lltcE {
    0% {
        width: 0%;
    }

    25% {
        width: 50%;
    }

    50% {
        width: 75%;
    }

    75% {
        width: 85%;
    }

    100% {
        width: 100%;
    }
}

.page_newpageContent__kt3BY {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
    /* min-height: calc(100vh - 67px); */
    min-height: 100vh;
}

.page_newpageRight__42Zf5 {
    border-left: 1px solid #e6e6e6;
    margin-top: 0;
    max-height: calc(100vh - 67px);
    /* min-height: 100vh; */
    padding: 0;
    overflow-y: auto;
    position: relative;
    width: 410px;
}

.page_newpageLeft__vLOv9 {
    max-height: calc(100dvh - 100px);
    overflow-y: auto;
    /* margin-right: 36px; */
    padding-right: 80px;
    padding-left: 85px;
    width: calc(100% - 410px);
    padding-top: 30px;
}

.page_buttonsDesktop__Jza0h {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: block;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.page_buttonsMobile__n8MW9 {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: none;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.page_newpageRightButtons__TioUv {
    display: inline-flex;
    position: relative;
    height: 44px;
}

.page_newpageRightButtons__TioUv button {
    font-family: 'CyGrotesk-KeyRegular';
}

.page_newpageRightButtons__TioUv button:first-child {
    border-radius: 6px;
}

.page_newpageRightButtons__TioUv button:first-child {
    border-radius: 4px;
    background: #0a0a0a;
}

.page_newpageRightButtons__TioUv button:first-child {
    /* background: #0a0a0a; */
    margin-right: 8px;
    /* min-width: 69px; */
    min-height: 42px;
    position: relative;
    justify-content: center;
    border-radius: 6px !important;
}

.page_newpageRightButtons__TioUv .page_publishButton__yfR8e {
    width: 97.3px;
}

.page_newpageRightButtons__TioUv button {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    gap: 8px;
    /* border-radius: 6px; */
    align-items: center;
    padding: 10px;
    /* border: none; */
    /* color: #fff; */
    cursor: pointer;
}

.page_addNewCategoryButton__Q5xTU {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    box-shadow: 0 1px 3px #0000001a;
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
}

.page_primaryButton__rLFzu {
    box-shadow: 0 1px 3px #0000001a;
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
}

.page_newpageRightButtons__TioUv button:first-child p {
    font-weight: 600;
}

.page_newpageRightButtons__TioUv button:nth-child(2) {
    margin-right: 8px;
}

.page_newpageRightButtons__TioUv .page_draftButton__KoTJM {
    width: 120px;
}

.page_newpageRightButtons__TioUv button {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    gap: 8px;
    /* border-radius: 6px; */
    align-items: center;
    padding: 10px;
    /* border: none; */
    /* color: #fff; */
    cursor: pointer;
}

.page_secondaryButton__F8L43 {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
}

.page_newpageRight__42Zf5>.page_newPageRightRow__IesP9 {
    border-bottom: 1px solid #e6e6e6;
    border-top: 0;
    overflow: hidden;
    padding: 20px 30px;
}

.page_newPageRightFullUrl__crJZT,
.page_newPageRightTitle__TPL40 {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
}

.page_iconDropWrap__Dubn5 {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 0;
}

.page_iconDropWrap__Dubn5 span {
    font-weight: 500;
    margin-right: 3px;
    width: calc(100% - 15px);
    display: block;
}

.page_newPageRight__cFkbu:has(.page_expanded__fYCP0) .page_dropdownIcon__kAFgy,
.page_newPageRightRow__IesP9:has(.page_expanded__fYCP0) .page_dropdownIcon__kAFgy {
    transform: rotate(-180deg);
}

.page_dropdownIcon__kAFgy {
    transition: all 0.2s linear;
    width: 12px;
}

.page_expanded__fYCP0 {
    max-height: 1000px;
    transition: max-height 0.8s ease-in-out 0s;
}

.page_collapse__32jei {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.6s ease-in-out 0s;
}

.page_urlInput__rWoGx {
    display: block;
    width: 100%;
}

.page_adressInputBlock__rlJBy {
    position: relative;
}

.page_adressInputBlock__rlJBy .page_adressLink__yInR2 {
    top: 24px;
}

.page_adressLink__yInR2,
.page_publication-Link__nk-Tw .page_adressInputBlock__rlJBy .page_url-icon__dF68p {
    left: 14px;
    position: absolute;
    top: 1.48rem;
    width: 17px;
    height: 17px;
}

.page_adressInputBlock__rlJBy.page_urlInput__rWoGx>input {
    padding-left: 40px;
}

.page_adressInputBlock__rlJBy input,
.page_textExpert__XBpRH {
    padding: 8px 12px;
    gap: 8px;
    height: 45px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 40px;
    font-size: 14px;
}

.page_stockManage__lkGz3 .page_quantitySection__8FRCN input,
.page_skuSection__KptQf input {
    padding: 8px 12px;
}

.page_stockManage__lkGz3 .page_trackStock__dOvoh input {
    padding: 0;
    margin: 0;
    height: auto;
    width: auto;
}

.page_stockManage__lkGz3 .page_trackStock__dOvoh input[type="checkbox"]:before {
    margin-right: 0;
}

.page_stockManage__lkGz3 .page_trackStock__dOvoh p {
    margin: 0;
    font-size: 14px;
}

.page_priceInputs__rIHpc {
    margin-top: 5px;
    display: flex;
    gap: 10px;
}

.page_priceInputs__rIHpc .page_priceInputGroup__dh3Cp {
    flex: 1 1;
}

.page_stockManage__lkGz3 .page_trackStock__dOvoh {
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.page_stockManage__lkGz3 {
    margin-top: 5px;
}

.page_quantitySection__8FRCN,
.page_stockManage__lkGz3 .page_trackStock__dOvoh,
.page_skuSection__KptQf {
    margin-top: 10px;
}

.page_priceInputGroup__dh3Cp label,
.page_stockManage__lkGz3 label {
    font-size: 14px;
}

.page_priceInputGroup__dh3Cp input {
    padding: 8px 12px;
    margin-top: 5px;
}

.page_textExpert__XBpRH {
    resize: vertical;
    overflow-x: hidden;
    min-height: calc(1.2em * 5);
    padding: 8px 12px;
}

.page_listSearch__LeDp1 p {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
}

.page_newpageRight__42Zf5>.page_desktopFeatures__keg\\+D {
    border-bottom: 1px solid #eaecf0;
}

.page_newpageRight__42Zf5>.page_desktopFeatures__keg\\+D:has(.page_expanded__fYCP0) {
    border-color: transparent;
}

.page_newpageRight__42Zf5>.page_newPageRight__cFkbu {
    padding: 20px 30px;
}

.page_newPageRightRow__IesP9.page_imageUploadBox__Uo5kO {
    margin-top: 10px;
    height: 200px;
    position: relative;
    border: 1px solid black;
    border-radius: 6px;
}

.page_newpageImageUpload__r4rNC {
    background: #fff;
    border: 1px solid #eaecf0;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
    min-height: 100%;
    max-width: 384px;
    position: relative;
    z-index: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* .newpageImageUpload:has(.featureImgMiddleContent) {
    min-height: 215px;
} */

.page_fileUploadCover_Img__Cn36d {
    margin: 0 auto;
    display: block;
}

.page_fileUploadBox__rz-sT .page_fileUploadCover_Img__Cn36d {
    margin: 0 auto;
    background: #f2f4f7;
    border: 6px solid #f9fafb;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    padding: 5px !important;
    margin-bottom: 5px;
}

.page_newpageImageUpload__r4rNC .page_featureImgMiddleContent__GcsB\\+,
.page_newpageImageUpload__r4rNC div .page_newpage_CoverImg__nJojM,
.page_newpageImageUpload__r4rNC .page_featureImgMiddleContent__GcsB\\+,
.page_newpageImageUpload__r4rNC div .page_newpage_CoverImg__nJojM,
.page_newpageImageUpload__r4rNC .page_featureImgMiddleContent__GcsB\\+,
.page_newpageImageUpload__r4rNC div .page_newpage_CoverImg__nJojM {
    width: 100%;
    height: 100%;
    min-height: 100%;
    max-width: 100%;
}

.page_newPageImageUploadText__OmIX\\+ {
    font-weight: 400;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    color: #475467;
    -webkit-user-select: none;
            user-select: none;
    text-align: center;
    padding-top: 10px;
}

.page_newPageImageUploadText__OmIX\\+ span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1c1c1c;
}

.page_contentDrop__Ji048>div.page_scheduleCheckbox__dSuYL {
    margin-top: 9px;
    position: relative;
}

.page_listSearch__LeDp1 label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
}

.page_listSearch__LeDp1 input[type="checkbox"] {
    font-size: 0;
    width: 18px;
    height: 18px;
    border: 1px solid transparent;
    -o-appearance: none;
    appearance: none;
    position: relative;
    padding: 0 0 0 0;
    margin: 0;
    margin-right: 9px !important;
    box-shadow: none;
}

.page_listSearch__LeDp1 input[type="checkbox"]:before {
    position: absolute;
    left: 0;
    top: -1px;
    margin-right: 0;
}

.page_scheduleCheckbox__dSuYL p {
    text-transform: unset;
}

.page_listSearch__LeDp1 p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
}

.page_verticleDots__yjfPV {
    position: relative;
    left: 0;
}

/* .productListHeight {
    overflow-y: hidden;
} */

.page_productDatatableList__T3ul4 {
    padding: 30px 30px 0;
}

.page_productHeader__iIbO\\+ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
}

.page_leftSide__y81Bj {
    display: flex;
    align-items: center;
    gap: 10px;
}

.page_searchBar__AXyiu {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    min-width: 370px;
    height: 40px;
}

.page_searchBar__AXyiu img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}

.page_searchBar__AXyiu input {
    border: none;
    outline: none;
    padding: 8px 0;
    width: 100%;
    font-size: 14px;
}

.page_searchBar__AXyiu input::placeholder {
    color: #667085;
}

.page_productHeader__iIbO\\+ .page_productHeading__DmgPK {
    font-size: 20px;
    font-weight: 600;
}

.page_addBtn__YIxQM {
    background: #000;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
}

.page_actionButtonsDeleteAdd__ncr1z {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.page_deleteSelectedBtn__0F4R4 {
    cursor: pointer;
}

/* Left side */
.page_editorBlock__R31kD {
    max-width: 740px;
    margin: auto;
    padding: 0 20px;
    margin-top: 30px;
    position: relative;
    top: 0;
}

#page_postTitle__XThVz {
    font-style: normal;
    font-weight: 500;
    gap: 8px;
    outline: none;
    border: none;
    width: 100%;
    font-size: 36px;
    box-shadow: none;
    background: transparent;
    padding: 0;
    color: #1c1c1c;
    line-height: 48px;
}

.page_newpageLeftRow__COHT5 input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #000;
    padding: 14px 14px 12px;
    gap: 8px;
    background: #fff;
    border-radius: 6px;
    outline: none;
    border: none;
    width: 100%;
}

#page_postTitle__XThVz[placeholder]:empty:before {
    content: attr(placeholder);
    color: #667085;
}


.page_listSearch__LeDp1 input[type="checkbox"] {
    font-size: 0;
    width: 18px;
    height: 18px;
    border: 1px solid transparent;
    -o-appearance: none;
    appearance: none;
    position: relative;
    padding: 0 0 0 0;
    margin: 0;
    margin-right: 9px !important;
    box-shadow: none;
}

.page_listSearch__LeDp1 li:first-child {
    margin-top: 5px;
}

.page_listSearch__LeDp1 li {
    margin: 12px 0;
}

.page_listSearch__LeDp1 label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
}

.page_listSearch__LeDp1 input[type="checkbox"]:before {
    position: absolute;
    left: 0;
    top: -1px;
    margin-right: 0;
}

.page_listSearch__LeDp1 p {
    color: var(--cloudburst);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

.page_categoriesList__ErsFA {
    max-height: 165px;
    overflow-y: auto;
    padding-left: 0;
    margin-bottom: 10px;
    margin-top: 0;
    margin-bottom: 0;
}

.page_categoryPageSearch__E42K1 {
    position: relative;
}

.page_categoryPageSearch__E42K1 img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
}

.page_ratingBox__uDTYo {
    display: flex;
    flex-direction: column;
    border: 1px solid #d0d5dd;
    border-radius: 4px;
}

.page_ratingRow__tm2at {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    border-bottom: 1px solid #d0d5dd;
    padding: 10px 12px;
    gap: 0 10px;
}

.page_ratingRow__tm2at:last-child {
    border-bottom: none;
    margin-bottom: 0;
}

.page_ratingLabels__o5\\+Cc {
    font-size: 16px;
    color: #000;
    font-weight: 500;
    margin: 0;
}

.page_ratingStars__X5xLZ {
    display: flex;
    gap: 10px;
}

.page_ratingStar__5gN\\+P {
    width: 28px !important;
    height: 28px !important;
    cursor: pointer;
    transition: 0.2s ease;
}

.page_approveBtn__BjBdN {
    background: #279134;
    border: 1px solid #279134;
    color: #fff;
    padding: 2px 8px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 5px;
    font-size: 13px;
}

.page_pendingBtn__4nnnI {
    background: #d4d4d4;
    border: 1px solid #d4d4d4;
    color: #000;
    padding: 2px 8px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 5px;
    font-size: 13px;
}

.page_denyBtn__vLAyy {
    background: #c32323;
    border: 1px solid #c32323;
    color: #fff;
    padding: 2px 8px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 5px;
    font-size: 13px;
}

.page_newpageRight__42Zf5>.page_newPageRightRow__IesP9.page_brandDropdown__ZNBYt:has(.page_expanded__fYCP0),
.page_newpageRight__42Zf5>.page_newPageRightRow__IesP9.page_brandDropdown__ZNBYt:has(.page_expanded__fYCP0) .page_contentDrop__Ji048 {
    overflow: visible;
}

.page_checkboxLabel__lU-Al{
    display: flex;
    align-items: center;
}

.page_checkboxLabel__lU-Al input{
    width: auto;
    padding: 0;
}

.page_checkboxLabel__lU-Al input[type="checkbox"]:before {
    margin-right: 5px;
}

.page_fieldGroup__AoJsM {
    margin-bottom: 20px;
}

.page_productInputLabel__qlJlC {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: black;
    margin-bottom: 6px;
}

.page_descriptionTextarea__ZC-NF {
    width: 100%;
    min-height: 150px;
    padding: 10px 12px;
    font-size: 14px;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    resize: none;
    overflow: hidden;
}

.page_descriptionTextarea__ZC-NF::placeholder {
    color: #9b9b9b;
}

.page_newpageLeftRow__COHT5 input.page_productInput__mDJxF {
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid #d0d5dd;
    font-size: 14px;
}

.page_secondaryButton__F8L43 {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
}

.page_updatePagebtn__O5QsY {
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
    box-shadow: 0 1px 3px #0000001a;
}

.page_updateDraftButton__KLIg1 {
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
    box-shadow: 0 1px 3px #0000001a;
}

.page_newpageMoreButtons__bVUyI {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
    width: 44px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page_actionDots__iMX95 {
    width: 16px;
    height: 16px;
}


.page_publishButton__yfR8e {
    width: 97.3px;
}

.page_updatePagebtn__O5QsY {
    width: 74.83px;
}

.page_updateDraftButton__KLIg1 {
    width: 116.92px;
}

.page_draftButton__KoTJM {
    width: 120px;
}

.page_buttonsMobile__n8MW9 .page_publishedButtonsList__kfXLt {
    top: -90px;
}

.page_publishedButtonsList__kfXLt {
    position: absolute;
    top: 50px;
    right: 0;
    background: #fff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 10;
    min-width: 150px;
}

.page_publishedButtonsList__kfXLt ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.page_publishedButtonsList__kfXLt li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #344054;
}

.page_publishedButtonsList__kfXLt li:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.page_publishedButtonsList__kfXLt li:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.page_publishedButtonsList__kfXLt li:hover {
    background-color: #f9fafb;
}

.page_specification__tXZl2 input {
    max-width: 500px;
}

.page_specification__tXZl2 .page_deleteButton__DdDBK {
    outline: none;
    border: 0;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
}

/* --- Gallery image CSS start --- */

.page_uploadCard__9s8n1:hover .page_uploadContent__gqNCv {
    opacity: 1;
    visibility: visible;
}

.page_uploadItem__dlhW9:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    border-radius: 4px;
    background-color: #eaecf0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s linear;
}

.page_uploadContent__gqNCv {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s linear;
    background-color: #ffffff8c
}

.page_uploadGrid__nhQUU {
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    flex-wrap: wrap;
    margin: 22px -10px 0;
}

.page_uploadItem__dlhW9 img:not(.page_uploadClose__z-Wwo) {
    -webkit-user-select: none;
            user-select: none;
}

.page_uploadItem__dlhW9 {
    -webkit-user-select: none;
            user-select: none;
    cursor: grab;
    width: calc(20% - 20px);
    margin: 0 10px 20px;
    border-radius: 4px;
    border: 1px solid var(--lightgrey);
    background-color: var(--frostedwhite);
    position: relative;
}

.page_uploadContent__gqNCv .page_uploadDetails__sMv8S {
    display: flex;
    padding: 4px 15px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 6px;
    border: 1px solid var(--lightgrey);
    background: var(--white);
    box-shadow: 0px 10px 50px -3.75px rgba(0, 0, 0, 0.01),
        0px 2.29px 11.451px -2.5px rgba(0, 0, 0, 0.03),
        0px 0.603px 3.016px -1.25px rgba(0, 0, 0, 0.04);
    color: var(--fiord);
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    cursor: pointer;
    margin-top: 20px;
    transition: all 0.3s linear;
}

.page_uploadPicture__MxF0H,
.page_uploadPDF__7uwEz {
    position: relative;
}

.page_uploadPicture__MxF0H:before,
.page_uploadPDF__7uwEz:before {
    content: "";
    display: block;
    padding-top: 100%;
}

.page_uploadThumbnail__SGwMB {
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    transition: opacity 0.1s;
    object-fit: cover;
}

.page_uploadCard__9s8n1 {
    display: block;
    height: 100%;
    position: relative;
    border-radius: 4px;
}

.page_uploadCard__9s8n1 img {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
}

.page_uploadCard__9s8n1 .page_uploadClose__z-Wwo {
    pointer-events: unset;
    -webkit-user-select: unset;
            user-select: unset;
    height: 12px;
    width: 12px;
}

.page_uploadPictureCenter__k4j3d {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.page_uploadPicture__MxF0H img,
.page_uploadPDF__7uwEz img {
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
    border-radius: 4px;
    bottom: 0;
    right: 0;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
}

.page_uploadPDF__7uwEz img {
    object-fit: contain;
    height: auto;
    width: auto;
}

.page_uploadCard__9s8n1 .page_progressWrap__VrUDt {
    margin: auto;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
}

.page_uploadCard__9s8n1 .page_progressWrap__VrUDt .page_progress__lltcE {
    position: relative;
    height: 7px;
    width: 82%;
    border: 1px solid rgb(246, 246, 250);
    border-radius: 15px;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
}

.page_uploadCard__9s8n1 .page_progressWrap__VrUDt .page_progress__lltcE .page_color__z3tj0 {
    position: absolute;
    background-color: #573CFF;
    width: 0px;
    height: 6px;
    border-radius: 15px;
    animation: page_progress__lltcE 4s infinite linear;
}

.page_uploadClose__z-Wwo {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

.page_imageUploadClosed__z0GhV {
    background: var(--white);
    text-align: center;
    margin-top: 10px;
}

.page_uploadFileTextBlock__fEk1Q {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 20px;
    background: var(--white);
    height: 100%;
}

.page_uploadFileBlock__ssHeb {
    background: var(--white);
    border: 1px solid var(--lightgrey);
    border-radius: 6px;
    box-shadow: var(--boxshadow);
    min-height: 215px;
    max-width: 100%;
    position: relative;
    z-index: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.page_uploadFileBlock__ssHeb.page_preloadFile__TyfId {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    text-align: center;
}

.page_uploadFileBlock__ssHeb label {
    border: none;
    background: transparent;
    box-shadow: var(--boxshadow);
    border-radius: 8px;
    width: 100%;
    max-width: unset;
    z-index: 99;
}

.page_uploadFileText__yCJa5 {
    font-weight: 700;
}

.page_uploadFileText__yCJa5 {
    margin-bottom: 0 !important;
    padding-left: 10px;
    color: var(--grey);
}

.page_uploadFileText__yCJa5 span {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: var(--purple);
}

.page_fileItem__jrx2v {
    display: flex;
    align-items: center;
    background: var(--white);
    box-shadow: var(--boxshadow);
    border-radius: 12px;
    padding: 8px 16px;
    justify-content: space-between;
    margin-top: 15px;
}

.page_deleteIconWrapper__xNJYe {
    display: flex;
}

/* --- Gallery image CSS end --- */

.page_featuredImg__m2oyY {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 6px;
    object-fit: cover;
}

.page_contentDrop__Ji048 .page_progressWrap__VrUDt {
    margin: auto;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
}

.page_contentDrop__Ji048 .page_progressWrap__VrUDt .page_progress__lltcE {
    position: relative;
    height: 7px;
    width: 82%;
    border: 1px solid rgb(246, 246, 250);
    border-radius: 15px;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
}

.page_contentDrop__Ji048 .page_progressWrap__VrUDt .page_progress__lltcE .page_color__z3tj0 {
    position: absolute;
    background-color: #573CFF;
    width: 0px;
    height: 6px;
    border-radius: 15px;
    animation: page_progress__lltcE 4s infinite linear;
}

.page_saveButton__f0GIO {
    max-width: 61.41px !important;
}

.page_exportBtn__oOH4M {
    width: 153.38px;
    height: 39px;
}
.page_importBtn__B1Lqw {
    width: 153.64px;
    height: 39px;
}

.page_skuWrapper__ZOQmT {
    padding: 15px 0 0;
    display: flex;
    flex-direction: column;
    gap: 0;
}


@media screen and (max-width: 1260px) {
    .page_newpageContent__kt3BY {
        margin-top: 30px;
        flex-direction: column;
    }

    .page_buttonsDesktop__Jza0h {
        display: none;
    }

    .page_buttonsMobile__n8MW9 {
        display: block;
    }

    .page_newpageRight__42Zf5,
    .page_newpageLeft__vLOv9 {
        width: 100%;
        max-height: 100%
    }

    .page_newpageRight__42Zf5 .page_newPageRightRowURL__8TyOa {
        border-top: 1px solid #e6e6e6;
    }

}

@media screen and (max-width: 1024px) {
    .page_newpageImageUpload__r4rNC {
        margin-top: 15px;
    }

    .page_contentWrapper__RpDlE {
        margin-top: 0;
    }

}

@media screen and (max-width: 767px) {
    .page_newPageRightRow__IesP9 .page_newpageImageUpload__r4rNC {
        margin-top: 10px;
        max-width: 100%;
    }

    .page_newpageRight__42Zf5>.page_desktopFeatures__keg\\+D {
        margin-top: 0 !important;
    }

    .page_searchBar__AXyiu,
    .page_leftSide__y81Bj {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }
}

@media screen and (max-width: 490) {
    .page_fileUploadCover_Img__Cn36d {
        padding-top: 0 !important;
    }
}

@media screen and (max-width: 480) {
    .page_newPageRightRow__IesP9 .page_newpageImageUpload__r4rNC {
        width: 100%;
        max-width: 100%;
    }
}

@media screen and (max-width: 390) {
    .page_fileUploadCover_Img__Cn36d {
        padding-top: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Products/page.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;;;;;IAMI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;;GAEG;;AAEH;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAG7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mFAAmF;IACnF,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,UAAU;IACV,eAAe;AACnB;;AAEA,oCAAoC;;AAEpC;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,wBAAwB;IACxB;;uDAEmD;IACnD,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,0BAAkB;YAAlB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oCAAoC;IACpC,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kDAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,kCAAkC;;AAElC;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oCAAoC;IACpC,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kDAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;;AAGA;IACI;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI,6BAA6B;IACjC;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,wBAAwB;QACxB;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@keyframes progress {\n    0% {\n        width: 0%;\n    }\n\n    25% {\n        width: 50%;\n    }\n\n    50% {\n        width: 75%;\n    }\n\n    75% {\n        width: 85%;\n    }\n\n    100% {\n        width: 100%;\n    }\n}\n\n.newpageContent {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    /* min-height: calc(100vh - 67px); */\n    min-height: 100vh;\n}\n\n.newpageRight {\n    border-left: 1px solid #e6e6e6;\n    margin-top: 0;\n    max-height: calc(100vh - 67px);\n    /* min-height: 100vh; */\n    padding: 0;\n    overflow-y: auto;\n    position: relative;\n    width: 410px;\n}\n\n.newpageLeft {\n    max-height: calc(100dvh - 100px);\n    overflow-y: auto;\n    /* margin-right: 36px; */\n    padding-right: 80px;\n    padding-left: 85px;\n    width: calc(100% - 410px);\n    padding-top: 30px;\n}\n\n.buttonsDesktop {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: block;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.buttonsMobile {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: none;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.newpageRightButtons {\n    display: inline-flex;\n    position: relative;\n    height: 44px;\n}\n\n.newpageRightButtons button {\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 6px;\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 4px;\n    background: #0a0a0a;\n}\n\n.newpageRightButtons button:first-child {\n    /* background: #0a0a0a; */\n    margin-right: 8px;\n    /* min-width: 69px; */\n    min-height: 42px;\n    position: relative;\n    justify-content: center;\n    border-radius: 6px !important;\n}\n\n.newpageRightButtons .publishButton {\n    width: 97.3px;\n}\n\n.newpageRightButtons button {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    /* border-radius: 6px; */\n    align-items: center;\n    padding: 10px;\n    /* border: none; */\n    /* color: #fff; */\n    cursor: pointer;\n}\n\n.addNewCategoryButton {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    padding: 10px;\n    cursor: pointer;\n    box-shadow: 0 1px 3px #0000001a;\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n}\n\n.primaryButton {\n    box-shadow: 0 1px 3px #0000001a;\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n}\n\n.newpageRightButtons button:first-child p {\n    font-weight: 600;\n}\n\n.newpageRightButtons button:nth-child(2) {\n    margin-right: 8px;\n}\n\n.newpageRightButtons .draftButton {\n    width: 120px;\n}\n\n.newpageRightButtons button {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    /* border-radius: 6px; */\n    align-items: center;\n    padding: 10px;\n    /* border: none; */\n    /* color: #fff; */\n    cursor: pointer;\n}\n\n.secondaryButton {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.newpageRight>.newPageRightRow {\n    border-bottom: 1px solid #e6e6e6;\n    border-top: 0;\n    overflow: hidden;\n    padding: 20px 30px;\n}\n\n.newPageRightFullUrl,\n.newPageRightTitle {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.iconDropWrap {\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.iconDropWrap span {\n    font-weight: 500;\n    margin-right: 3px;\n    width: calc(100% - 15px);\n    display: block;\n}\n\n.newPageRight:has(.expanded) .dropdownIcon,\n.newPageRightRow:has(.expanded) .dropdownIcon {\n    transform: rotate(-180deg);\n}\n\n.dropdownIcon {\n    transition: all 0.2s linear;\n    width: 12px;\n}\n\n.expanded {\n    max-height: 1000px;\n    transition: max-height 0.8s ease-in-out 0s;\n}\n\n.collapse {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.6s ease-in-out 0s;\n}\n\n.urlInput {\n    display: block;\n    width: 100%;\n}\n\n.adressInputBlock {\n    position: relative;\n}\n\n.adressInputBlock .adressLink {\n    top: 24px;\n}\n\n.adressLink,\n.publication-Link .adressInputBlock .url-icon {\n    left: 14px;\n    position: absolute;\n    top: 1.48rem;\n    width: 17px;\n    height: 17px;\n}\n\n.adressInputBlock.urlInput>input {\n    padding-left: 40px;\n}\n\n.adressInputBlock input,\n.textExpert {\n    padding: 8px 12px;\n    gap: 8px;\n    height: 45px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding-left: 40px;\n    font-size: 14px;\n}\n\n.stockManage .quantitySection input,\n.skuSection input {\n    padding: 8px 12px;\n}\n\n.stockManage .trackStock input {\n    padding: 0;\n    margin: 0;\n    height: auto;\n    width: auto;\n}\n\n.stockManage .trackStock input[type=\"checkbox\"]:before {\n    margin-right: 0;\n}\n\n.stockManage .trackStock p {\n    margin: 0;\n    font-size: 14px;\n}\n\n.priceInputs {\n    margin-top: 5px;\n    display: flex;\n    gap: 10px;\n}\n\n.priceInputs .priceInputGroup {\n    flex: 1;\n}\n\n.stockManage .trackStock {\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.stockManage {\n    margin-top: 5px;\n}\n\n.quantitySection,\n.stockManage .trackStock,\n.skuSection {\n    margin-top: 10px;\n}\n\n.priceInputGroup label,\n.stockManage label {\n    font-size: 14px;\n}\n\n.priceInputGroup input {\n    padding: 8px 12px;\n    margin-top: 5px;\n}\n\n.textExpert {\n    resize: vertical;\n    overflow-x: hidden;\n    min-height: calc(1.2em * 5);\n    padding: 8px 12px;\n}\n\n.listSearch p {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.newpageRight>.desktopFeatures {\n    border-bottom: 1px solid #eaecf0;\n}\n\n.newpageRight>.desktopFeatures:has(.expanded) {\n    border-color: transparent;\n}\n\n.newpageRight>.newPageRight {\n    padding: 20px 30px;\n}\n\n.newPageRightRow.imageUploadBox {\n    margin-top: 10px;\n    height: 200px;\n    position: relative;\n    border: 1px solid black;\n    border-radius: 6px;\n}\n\n.newpageImageUpload {\n    background: #fff;\n    border: 1px solid #eaecf0;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n    min-height: 100%;\n    max-width: 384px;\n    position: relative;\n    z-index: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* .newpageImageUpload:has(.featureImgMiddleContent) {\n    min-height: 215px;\n} */\n\n.fileUploadCover_Img {\n    margin: 0 auto;\n    display: block;\n}\n\n.fileUploadBox .fileUploadCover_Img {\n    margin: 0 auto;\n    background: #f2f4f7;\n    border: 6px solid #f9fafb;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n    padding: 5px !important;\n    margin-bottom: 5px;\n}\n\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg,\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg,\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg {\n    width: 100%;\n    height: 100%;\n    min-height: 100%;\n    max-width: 100%;\n}\n\n.newPageImageUploadText {\n    font-weight: 400;\n    text-align: center;\n    font-size: 14px;\n    line-height: 24px;\n    color: #475467;\n    user-select: none;\n    text-align: center;\n    padding-top: 10px;\n}\n\n.newPageImageUploadText span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #1c1c1c;\n}\n\n.contentDrop>div.scheduleCheckbox {\n    margin-top: 9px;\n    position: relative;\n}\n\n.listSearch label {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    cursor: pointer;\n}\n\n.listSearch input[type=\"checkbox\"] {\n    font-size: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid transparent;\n    -o-appearance: none;\n    appearance: none;\n    position: relative;\n    padding: 0 0 0 0;\n    margin: 0;\n    margin-right: 9px !important;\n    box-shadow: none;\n}\n\n.listSearch input[type=\"checkbox\"]:before {\n    position: absolute;\n    left: 0;\n    top: -1px;\n    margin-right: 0;\n}\n\n.scheduleCheckbox p {\n    text-transform: unset;\n}\n\n.listSearch p {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n}\n\n.verticleDots {\n    position: relative;\n    left: 0;\n}\n\n/* .productListHeight {\n    overflow-y: hidden;\n} */\n\n.productDatatableList {\n    padding: 30px 30px 0;\n}\n\n.productHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.leftSide {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    min-width: 370px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n}\n\n.searchBar input {\n    border: none;\n    outline: none;\n    padding: 8px 0;\n    width: 100%;\n    font-size: 14px;\n}\n\n.searchBar input::placeholder {\n    color: #667085;\n}\n\n.productHeader .productHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.addBtn {\n    background: #000;\n    color: white;\n    padding: 10px 18px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.deleteSelectedBtn {\n    cursor: pointer;\n}\n\n/* Left side */\n.editorBlock {\n    max-width: 740px;\n    margin: auto;\n    padding: 0 20px;\n    margin-top: 30px;\n    position: relative;\n    top: 0;\n}\n\n#postTitle {\n    font-style: normal;\n    font-weight: 500;\n    gap: 8px;\n    outline: none;\n    border: none;\n    width: 100%;\n    font-size: 36px;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    color: #1c1c1c;\n    line-height: 48px;\n}\n\n.newpageLeftRow input {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #000;\n    padding: 14px 14px 12px;\n    gap: 8px;\n    background: #fff;\n    border-radius: 6px;\n    outline: none;\n    border: none;\n    width: 100%;\n}\n\n#postTitle[placeholder]:empty:before {\n    content: attr(placeholder);\n    color: #667085;\n}\n\n\n.listSearch input[type=\"checkbox\"] {\n    font-size: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid transparent;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    position: relative;\n    padding: 0 0 0 0;\n    margin: 0;\n    margin-right: 9px !important;\n    box-shadow: none;\n}\n\n.listSearch li:first-child {\n    margin-top: 5px;\n}\n\n.listSearch li {\n    margin: 12px 0;\n}\n\n.listSearch label {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    cursor: pointer;\n}\n\n.listSearch input[type=\"checkbox\"]:before {\n    position: absolute;\n    left: 0;\n    top: -1px;\n    margin-right: 0;\n}\n\n.listSearch p {\n    color: var(--cloudburst);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n.categoriesList {\n    max-height: 165px;\n    overflow-y: auto;\n    padding-left: 0;\n    margin-bottom: 10px;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.categoryPageSearch {\n    position: relative;\n}\n\n.categoryPageSearch img {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 12px;\n}\n\n.ratingBox {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #d0d5dd;\n    border-radius: 4px;\n}\n\n.ratingRow {\n    display: flex;\n    align-items: center;\n    /* justify-content: space-between; */\n    border-bottom: 1px solid #d0d5dd;\n    padding: 10px 12px;\n    gap: 0 10px;\n}\n\n.ratingRow:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n}\n\n.ratingLabels {\n    font-size: 16px;\n    color: #000;\n    font-weight: 500;\n    margin: 0;\n}\n\n.ratingStars {\n    display: flex;\n    gap: 10px;\n}\n\n.ratingStar {\n    width: 28px !important;\n    height: 28px !important;\n    cursor: pointer;\n    transition: 0.2s ease;\n}\n\n.approveBtn {\n    background: #279134;\n    border: 1px solid #279134;\n    color: #fff;\n    padding: 2px 8px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-right: 5px;\n    font-size: 13px;\n}\n\n.pendingBtn {\n    background: #d4d4d4;\n    border: 1px solid #d4d4d4;\n    color: #000;\n    padding: 2px 8px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-right: 5px;\n    font-size: 13px;\n}\n\n.denyBtn {\n    background: #c32323;\n    border: 1px solid #c32323;\n    color: #fff;\n    padding: 2px 8px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-right: 5px;\n    font-size: 13px;\n}\n\n.newpageRight>.newPageRightRow.brandDropdown:has(.expanded),\n.newpageRight>.newPageRightRow.brandDropdown:has(.expanded) .contentDrop {\n    overflow: visible;\n}\n\n.checkboxLabel{\n    display: flex;\n    align-items: center;\n}\n\n.checkboxLabel input{\n    width: auto;\n    padding: 0;\n}\n\n.checkboxLabel input[type=\"checkbox\"]:before {\n    margin-right: 5px;\n}\n\n.fieldGroup {\n    margin-bottom: 20px;\n}\n\n.productInputLabel {\n    display: block;\n    font-size: 16px;\n    font-weight: 500;\n    color: black;\n    margin-bottom: 6px;\n}\n\n.descriptionTextarea {\n    width: 100%;\n    min-height: 150px;\n    padding: 10px 12px;\n    font-size: 14px;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    resize: none;\n    overflow: hidden;\n}\n\n.descriptionTextarea::placeholder {\n    color: #9b9b9b;\n}\n\n.newpageLeftRow input.productInput {\n    padding: 8px 12px;\n    border-radius: 6px;\n    border: 1px solid #d0d5dd;\n    font-size: 14px;\n}\n\n.secondaryButton {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.updatePagebtn {\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.updateDraftButton {\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.newpageMoreButtons {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n    width: 44px;\n    height: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.actionDots {\n    width: 16px;\n    height: 16px;\n}\n\n\n.publishButton {\n    width: 97.3px;\n}\n\n.updatePagebtn {\n    width: 74.83px;\n}\n\n.updateDraftButton {\n    width: 116.92px;\n}\n\n.draftButton {\n    width: 120px;\n}\n\n.buttonsMobile .publishedButtonsList {\n    top: -90px;\n}\n\n.publishedButtonsList {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    background: #fff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    min-width: 150px;\n}\n\n.publishedButtonsList ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.publishedButtonsList li {\n    padding: 10px 15px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #344054;\n}\n\n.publishedButtonsList li:first-child {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n}\n\n.publishedButtonsList li:last-child {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n}\n\n.publishedButtonsList li:hover {\n    background-color: #f9fafb;\n}\n\n.specification input {\n    max-width: 500px;\n}\n\n.specification .deleteButton {\n    outline: none;\n    border: 0;\n    background-color: transparent;\n    padding: 0;\n    cursor: pointer;\n}\n\n/* --- Gallery image CSS start --- */\n\n.uploadCard:hover .uploadContent {\n    opacity: 1;\n    visibility: visible;\n}\n\n.uploadItem:after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    border-radius: 4px;\n    background-color: #eaecf0;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s linear;\n}\n\n.uploadContent {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s linear;\n    background-color: #ffffff8c\n}\n\n.uploadGrid {\n    user-select: none;\n    display: flex;\n    flex-wrap: wrap;\n    margin: 22px -10px 0;\n}\n\n.uploadItem img:not(.uploadClose) {\n    user-select: none;\n}\n\n.uploadItem {\n    user-select: none;\n    cursor: grab;\n    width: calc(20% - 20px);\n    margin: 0 10px 20px;\n    border-radius: 4px;\n    border: 1px solid var(--lightgrey);\n    background-color: var(--frostedwhite);\n    position: relative;\n}\n\n.uploadContent .uploadDetails {\n    display: flex;\n    padding: 4px 15px;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 6px;\n    border: 1px solid var(--lightgrey);\n    background: var(--white);\n    box-shadow: 0px 10px 50px -3.75px rgba(0, 0, 0, 0.01),\n        0px 2.29px 11.451px -2.5px rgba(0, 0, 0, 0.03),\n        0px 0.603px 3.016px -1.25px rgba(0, 0, 0, 0.04);\n    color: var(--fiord);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 24px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: all 0.3s linear;\n}\n\n.uploadPicture,\n.uploadPDF {\n    position: relative;\n}\n\n.uploadPicture:before,\n.uploadPDF:before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n}\n\n.uploadThumbnail {\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    opacity: 1;\n    transition: opacity 0.1s;\n    object-fit: cover;\n}\n\n.uploadCard {\n    display: block;\n    height: 100%;\n    position: relative;\n    border-radius: 4px;\n}\n\n.uploadCard img {\n    user-select: none;\n    pointer-events: none;\n}\n\n.uploadCard .uploadClose {\n    pointer-events: unset;\n    user-select: unset;\n    height: 12px;\n    width: 12px;\n}\n\n.uploadPictureCenter {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.uploadPicture img,\n.uploadPDF img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: auto;\n    border-radius: 4px;\n    bottom: 0;\n    right: 0;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: cover;\n    object-position: center;\n    height: 100%;\n    width: 100%;\n}\n\n.uploadPDF img {\n    object-fit: contain;\n    height: auto;\n    width: auto;\n}\n\n.uploadCard .progressWrap {\n    margin: auto;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 100%;\n}\n\n.uploadCard .progressWrap .progress {\n    position: relative;\n    height: 7px;\n    width: 82%;\n    border: 1px solid rgb(246, 246, 250);\n    border-radius: 15px;\n    top: 50%;\n    left: 16px;\n    transform: translateY(-50%);\n}\n\n.uploadCard .progressWrap .progress .color {\n    position: absolute;\n    background-color: #573CFF;\n    width: 0px;\n    height: 6px;\n    border-radius: 15px;\n    animation: progress 4s infinite linear;\n}\n\n.uploadClose {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n}\n\n.imageUploadClosed {\n    background: var(--white);\n    text-align: center;\n    margin-top: 10px;\n}\n\n.uploadFileTextBlock {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding-left: 20px;\n    background: var(--white);\n    height: 100%;\n}\n\n.uploadFileBlock {\n    background: var(--white);\n    border: 1px solid var(--lightgrey);\n    border-radius: 6px;\n    box-shadow: var(--boxshadow);\n    min-height: 215px;\n    max-width: 100%;\n    position: relative;\n    z-index: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.uploadFileBlock.preloadFile {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    text-align: center;\n}\n\n.uploadFileBlock label {\n    border: none;\n    background: transparent;\n    box-shadow: var(--boxshadow);\n    border-radius: 8px;\n    width: 100%;\n    max-width: unset;\n    z-index: 99;\n}\n\n.uploadFileText {\n    font-weight: 700;\n}\n\n.uploadFileText {\n    margin-bottom: 0 !important;\n    padding-left: 10px;\n    color: var(--grey);\n}\n\n.uploadFileText span {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--purple);\n}\n\n.fileItem {\n    display: flex;\n    align-items: center;\n    background: var(--white);\n    box-shadow: var(--boxshadow);\n    border-radius: 12px;\n    padding: 8px 16px;\n    justify-content: space-between;\n    margin-top: 15px;\n}\n\n.deleteIconWrapper {\n    display: flex;\n}\n\n/* --- Gallery image CSS end --- */\n\n.featuredImg {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    border-radius: 6px;\n    object-fit: cover;\n}\n\n.contentDrop .progressWrap {\n    margin: auto;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 100%;\n}\n\n.contentDrop .progressWrap .progress {\n    position: relative;\n    height: 7px;\n    width: 82%;\n    border: 1px solid rgb(246, 246, 250);\n    border-radius: 15px;\n    top: 50%;\n    left: 16px;\n    transform: translateY(-50%);\n}\n\n.contentDrop .progressWrap .progress .color {\n    position: absolute;\n    background-color: #573CFF;\n    width: 0px;\n    height: 6px;\n    border-radius: 15px;\n    animation: progress 4s infinite linear;\n}\n\n.saveButton {\n    max-width: 61.41px !important;\n}\n\n.exportBtn {\n    width: 153.38px;\n    height: 39px;\n}\n.importBtn {\n    width: 153.64px;\n    height: 39px;\n}\n\n.skuWrapper {\n    padding: 15px 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n\n@media screen and (max-width: 1260px) {\n    .newpageContent {\n        margin-top: 30px;\n        flex-direction: column;\n    }\n\n    .buttonsDesktop {\n        display: none;\n    }\n\n    .buttonsMobile {\n        display: block;\n    }\n\n    .newpageRight,\n    .newpageLeft {\n        width: 100%;\n        max-height: 100%\n    }\n\n    .newpageRight .newPageRightRowURL {\n        border-top: 1px solid #e6e6e6;\n    }\n\n}\n\n@media screen and (max-width: 1024px) {\n    .newpageImageUpload {\n        margin-top: 15px;\n    }\n\n    .contentWrapper {\n        margin-top: 0;\n    }\n\n}\n\n@media screen and (max-width: 767px) {\n    .newPageRightRow .newpageImageUpload {\n        margin-top: 10px;\n        max-width: 100%;\n    }\n\n    .newpageRight>.desktopFeatures {\n        margin-top: 0 !important;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n}\n\n@media screen and (max-width: 490) {\n    .fileUploadCover_Img {\n        padding-top: 0 !important;\n    }\n}\n\n@media screen and (max-width: 480) {\n    .newPageRightRow .newpageImageUpload {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 390) {\n    .fileUploadCover_Img {\n        padding-top: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newpageContent": `page_newpageContent__kt3BY`,
	"newpageRight": `page_newpageRight__42Zf5`,
	"newpageLeft": `page_newpageLeft__vLOv9`,
	"buttonsDesktop": `page_buttonsDesktop__Jza0h`,
	"buttonsMobile": `page_buttonsMobile__n8MW9`,
	"newpageRightButtons": `page_newpageRightButtons__TioUv`,
	"publishButton": `page_publishButton__yfR8e`,
	"addNewCategoryButton": `page_addNewCategoryButton__Q5xTU`,
	"primaryButton": `page_primaryButton__rLFzu`,
	"draftButton": `page_draftButton__KoTJM`,
	"secondaryButton": `page_secondaryButton__F8L43`,
	"newPageRightRow": `page_newPageRightRow__IesP9`,
	"newPageRightFullUrl": `page_newPageRightFullUrl__crJZT`,
	"newPageRightTitle": `page_newPageRightTitle__TPL40`,
	"iconDropWrap": `page_iconDropWrap__Dubn5`,
	"newPageRight": `page_newPageRight__cFkbu`,
	"expanded": `page_expanded__fYCP0`,
	"dropdownIcon": `page_dropdownIcon__kAFgy`,
	"collapse": `page_collapse__32jei`,
	"urlInput": `page_urlInput__rWoGx`,
	"adressInputBlock": `page_adressInputBlock__rlJBy`,
	"adressLink": `page_adressLink__yInR2`,
	"publication-Link": `page_publication-Link__nk-Tw`,
	"url-icon": `page_url-icon__dF68p`,
	"textExpert": `page_textExpert__XBpRH`,
	"stockManage": `page_stockManage__lkGz3`,
	"quantitySection": `page_quantitySection__8FRCN`,
	"skuSection": `page_skuSection__KptQf`,
	"trackStock": `page_trackStock__dOvoh`,
	"priceInputs": `page_priceInputs__rIHpc`,
	"priceInputGroup": `page_priceInputGroup__dh3Cp`,
	"listSearch": `page_listSearch__LeDp1`,
	"desktopFeatures": `page_desktopFeatures__keg+D`,
	"imageUploadBox": `page_imageUploadBox__Uo5kO`,
	"newpageImageUpload": `page_newpageImageUpload__r4rNC`,
	"fileUploadCover_Img": `page_fileUploadCover_Img__Cn36d`,
	"fileUploadBox": `page_fileUploadBox__rz-sT`,
	"featureImgMiddleContent": `page_featureImgMiddleContent__GcsB+`,
	"newpage_CoverImg": `page_newpage_CoverImg__nJojM`,
	"newPageImageUploadText": `page_newPageImageUploadText__OmIX+`,
	"contentDrop": `page_contentDrop__Ji048`,
	"scheduleCheckbox": `page_scheduleCheckbox__dSuYL`,
	"verticleDots": `page_verticleDots__yjfPV`,
	"productDatatableList": `page_productDatatableList__T3ul4`,
	"productHeader": `page_productHeader__iIbO+`,
	"leftSide": `page_leftSide__y81Bj`,
	"searchBar": `page_searchBar__AXyiu`,
	"productHeading": `page_productHeading__DmgPK`,
	"addBtn": `page_addBtn__YIxQM`,
	"actionButtonsDeleteAdd": `page_actionButtonsDeleteAdd__ncr1z`,
	"deleteSelectedBtn": `page_deleteSelectedBtn__0F4R4`,
	"editorBlock": `page_editorBlock__R31kD`,
	"postTitle": `page_postTitle__XThVz`,
	"newpageLeftRow": `page_newpageLeftRow__COHT5`,
	"categoriesList": `page_categoriesList__ErsFA`,
	"categoryPageSearch": `page_categoryPageSearch__E42K1`,
	"ratingBox": `page_ratingBox__uDTYo`,
	"ratingRow": `page_ratingRow__tm2at`,
	"ratingLabels": `page_ratingLabels__o5+Cc`,
	"ratingStars": `page_ratingStars__X5xLZ`,
	"ratingStar": `page_ratingStar__5gN+P`,
	"approveBtn": `page_approveBtn__BjBdN`,
	"pendingBtn": `page_pendingBtn__4nnnI`,
	"denyBtn": `page_denyBtn__vLAyy`,
	"brandDropdown": `page_brandDropdown__ZNBYt`,
	"checkboxLabel": `page_checkboxLabel__lU-Al`,
	"fieldGroup": `page_fieldGroup__AoJsM`,
	"productInputLabel": `page_productInputLabel__qlJlC`,
	"descriptionTextarea": `page_descriptionTextarea__ZC-NF`,
	"productInput": `page_productInput__mDJxF`,
	"updatePagebtn": `page_updatePagebtn__O5QsY`,
	"updateDraftButton": `page_updateDraftButton__KLIg1`,
	"newpageMoreButtons": `page_newpageMoreButtons__bVUyI`,
	"actionDots": `page_actionDots__iMX95`,
	"publishedButtonsList": `page_publishedButtonsList__kfXLt`,
	"specification": `page_specification__tXZl2`,
	"deleteButton": `page_deleteButton__DdDBK`,
	"uploadCard": `page_uploadCard__9s8n1`,
	"uploadContent": `page_uploadContent__gqNCv`,
	"uploadItem": `page_uploadItem__dlhW9`,
	"uploadGrid": `page_uploadGrid__nhQUU`,
	"uploadClose": `page_uploadClose__z-Wwo`,
	"uploadDetails": `page_uploadDetails__sMv8S`,
	"uploadPicture": `page_uploadPicture__MxF0H`,
	"uploadPDF": `page_uploadPDF__7uwEz`,
	"uploadThumbnail": `page_uploadThumbnail__SGwMB`,
	"uploadPictureCenter": `page_uploadPictureCenter__k4j3d`,
	"progressWrap": `page_progressWrap__VrUDt`,
	"progress": `page_progress__lltcE`,
	"color": `page_color__z3tj0`,
	"imageUploadClosed": `page_imageUploadClosed__z0GhV`,
	"uploadFileTextBlock": `page_uploadFileTextBlock__fEk1Q`,
	"uploadFileBlock": `page_uploadFileBlock__ssHeb`,
	"preloadFile": `page_preloadFile__TyfId`,
	"uploadFileText": `page_uploadFileText__yCJa5`,
	"fileItem": `page_fileItem__jrx2v`,
	"deleteIconWrapper": `page_deleteIconWrapper__xNJYe`,
	"featuredImg": `page_featuredImg__m2oyY`,
	"saveButton": `page_saveButton__f0GIO`,
	"exportBtn": `page_exportBtn__oOH4M`,
	"importBtn": `page_importBtn__B1Lqw`,
	"skuWrapper": `page_skuWrapper__ZOQmT`,
	"newPageRightRowURL": `page_newPageRightRowURL__8TyOa`,
	"contentWrapper": `page_contentWrapper__RpDlE`
};
export default ___CSS_LOADER_EXPORT___;
